import {
    HttpResponse,
    CategoryModel,
    QueryModel,
    RequestParams,
    CategoryModelIEnumerableApiResultSuccess,
    CategoryModelApiResultSuccess,
    ApiResultFailed,
    Operation,
    AggregationModel,
    AggregationResponse,
    GrouppedQueryModel
} from "@/libs/Api";
import ApiService from "@/libs/core/api-service"
import {CrudDataQuery, CrudService} from '@/libs/core/+state/models/crud-service';
import {CrudEnumerableResponse, CrudResponse} from "../core/+state/models/crud-response";
import {CrudPartialUpdatePatch} from '@/libs/core/+state/models/crud-partial-update-patch';

export class CategoriesDataService implements CrudService<CategoryModel, CategoryModel> {
    getAll(query: CrudDataQuery<CategoryModel>): Promise<CrudEnumerableResponse<CategoryModel>> {
        return ApiService.api.getCategoryBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    getBasicAll(query: CrudDataQuery<CategoryModel>): Promise<CrudEnumerableResponse<CategoryModel>> {
        throw new Error('NotImplemented');
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<CategoryModel>> {
        return ApiService.api.getCategoryById(id, params);
    }

    create(item: CategoryModel, params?: RequestParams): Promise<CrudResponse<CategoryModel>> {
        return ApiService.api.insertCategory(item, params);
    }

    update(item: CategoryModel, params?: RequestParams): Promise<CategoryModel> {
        return ApiService.api.updateCategory(item.id as Required<string>, item, params).then((req: any) => req.data.returnValue);
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<CategoryModel> {
        return ApiService.api.patchCategory(id, patches, params).then((req: any) => req.data.returnValue);
    }

    delete(query: CrudDataQuery<CategoryModel>): Promise<CrudEnumerableResponse<CategoryModel>> {
        return ApiService.api.deleteCategories(<any>query.data, query.params).then((req: any) => req.data.returnValue);
    }

    getAggregation(query: AggregationModel, params?: RequestParams): Promise<AggregationResponse> {
        return ApiService.api.aggregationCategory(query, params).then((req: any) => req.data.returnValue);
    }
    
    download(query: CrudDataQuery<CategoryModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        throw new Error('NotImplemented');
    }

    clone(item: CategoryModel, params?: RequestParams): Promise<CrudResponse<CategoryModel>> {
        throw new Error('NotImplemented');
    }

    getGroupped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        return ApiService.api.getCategoryGroupped(query, params);
    }

}
